import { useDispatch } from 'react-redux'
import styled from '@emotion/styled'
import { feedbackPost } from '../redux/actions'
import SvgBandcamp from '../public/images/bandcamp2.svg'

const Link = styled.a`
  color: ${({ theme }) => theme.colors.bandcampBlue};
  letter-spacing: -0.01rem;
  text-decoration: none;
`

const Text = styled.span`
  position: relative;
  bottom: 3px;
`

const BandcampLink = ({ className, listId, url }) => {
  const dispatch = useDispatch()

  const onClick = () => {
    dispatch(
      feedbackPost({
        type: 'list:buy',
        list: listId,
        releaseUrl: url,
      })
    )
  }

  return (
    <Link
      className={className}
      href={url}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Text className="f7 f6-ns mr0">Buy</Text>
      <SvgBandcamp />
    </Link>
  )
}

export default BandcampLink
